module.exports = __webpack_public_path__ + "media/images/icons/outlined/scan-648f8c3e43471dd4908632cbab1af410.svg";